<template>
  <div :class="['text', patternClass, className]" :style="computedStyle">
    <slot />
  </div>
</template>

<script>
export default {
  name: "Text",
  props: {
    pattern: {
      type: String,
      default: "body1",
      validator: (value) =>
        ["body1", "body2", "body3", "h1", "h2", "h3", "h4", "h5"].includes(
          value,
        ),
    },
    weight: {
      type: Number,
      default: 400,
      validator: (value) =>
        [100, 200, 300, 400, 500, 600, 700, 800, 900].includes(value),
    },
    color: {
      type: String,
      default: "#fafafa",
    },
    height: {
      type: Number,
      default: 130,
    },
    align: {
      type: String,
      default: "left",
      validator: (value) => ["left", "center", "right"].includes(value),
    },
    wordBreak: {
      type: String,
      default: "break-all",
      validator: (value) =>
        ["break-all", "break-word", "keep-all", "normal"].includes(value),
    },
    textDecoration: {
      type: String,
      default: "none",
      validator: (value) =>
        ["none", "underline", "overline", "line-through"].includes(value),
    },
    className: {
      type: String,
      default: "",
    },
  },
  computed: {
    patternClass() {
      return `text_${this.pattern}`;
    },

    computedStyle() {
      return {
        fontWeight: this.weight,
        color: this.color,
        lineHeight: `${this.height}%`,
        textAlign: this.align,
        wordBreak: this.wordBreak,
        textDecoration: this.textDecoration,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.text {
  margin: 0;
  padding: 0;

  &_body1 {
    font-size: 16px;
  }

  &_body2 {
    font-size: 14px;
  }

  &_body3 {
    font-size: 12px;
  }

  &_h1 {
    font-size: 36px;
  }

  &_h2 {
    font-size: 32px;
  }

  &_h3 {
    font-size: 30px;
  }

  &_h4 {
    font-size: 20px;
  }

  &_h5 {
    font-size: 18px;
  }
}
</style>
